import { components } from "react-select";

import { formatUnitMeasure } from "@/services/Utils";

import classes from "./ProductInput.module.scss";

const ProductInput = (props) => {
	const data = props.data;

	return (
		<components.Option style={{ background: "red", minWidth: "100%", minHeight: "100" }} {...props}>
			<div className={classes.productOption}>
				<span>{data.label.toUpperCase()}</span>
				{data.unit_measurement && (
					<div>
						<strong> {formatUnitMeasure(data.unit_measurement)}</strong>
					</div>
				)}
			</div>
		</components.Option>
	);
};

export default ProductInput;
